import React, { Component } from 'react';
import { array, bool, func, number, shape, string } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import pickBy from 'lodash/pickBy';
import classNames from 'classnames';
import config from '../../config';
import routeConfiguration from '../../routeConfiguration';
import { isMobileGoNative } from '../../util/userAgent';
import { withViewport } from '../../util/contextHelpers';
import { parse, stringify } from '../../util/urlHelpers';
import { createResourceLocatorString, pathByRouteName } from '../../util/routes';
import { propTypes } from '../../util/types';
import {
  Button,
  LimitedAccessBanner,
  Logo,
  Modal,
  ModalMissingInformation,
  NamedLink,
  TopbarDesktop,
  TopbarMobileMenu,
} from '../../components';
import { TopbarSearchForm } from '../../forms';
import UniversitySearch from '../../forms/EditListingProfessionalInfoForm/UniversitySearch';

import MenuIcon from './MenuIcon';
import SearchIcon from './SearchIcon';
import css from './Topbar.module.css';

const MAX_MOBILE_SCREEN_WIDTH = 768;

const redirectToURLWithModalState = (props, modalStateParam) => {
  const { history, location } = props;
  const { pathname, search, state } = location;
  const searchString = `?${stringify({ [modalStateParam]: 'open', ...parse(search) })}`;
  history.push(`${pathname}${searchString}`, state);
};

const redirectToURLWithoutModalState = (props, modalStateParam) => {
  const { history, location } = props;
  const { pathname, search, state } = location;
  const queryParams = pickBy(parse(search), (v, k) => {
    return k !== modalStateParam;
  });
  const stringified = stringify(queryParams);
  const searchString = stringified ? `?${stringified}` : '';
  history.push(`${pathname}${searchString}`, state);
};

const GenericError = props => {
  const { show } = props;
  const classes = classNames(css.genericError, {
    [css.genericErrorVisible]: show,
  });
  return (
    <div className={classes}>
      <div className={css.genericErrorContent}>
        <p className={css.genericErrorText}>
          <FormattedMessage id="Topbar.genericError" />
        </p>
      </div>
    </div>
  );
};

GenericError.propTypes = {
  show: bool.isRequired,
};

class TopbarComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      textValue:"",
      athlete:"",
      gapYear: "",
      greekLife: "",
      school: "",
      service: "",
      track: "",
      showTransparent: props.transparent,
    };
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
    this.handleMobileMenuOpen = this.handleMobileMenuOpen.bind(this);
    this.handleMobileMenuClose = this.handleMobileMenuClose.bind(this);
    this.handleMobileSearchOpen = this.handleMobileSearchOpen.bind(this);
    this.handleMobileSearchClose = this.handleMobileSearchClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitMobile = this.handleSubmitMobile.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.setTextValue = this.setTextValue.bind(this);
    this.setAthleteValue = this.setAthleteValue.bind(this);
    this.setGapYearValue = this.setGapYearValue.bind(this);
    this.setGreekLifeValue = this.setGreekLifeValue.bind(this);
    this.setSchoolValue = this.setSchoolValue.bind(this);
    this.setServiceValue = this.setServiceValue.bind(this);
    this.setTrackValue = this.setTrackValue.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.mobileSearchFunction = this.mobileSearchFunction.bind(this);
  }


  componentDidMount() {
    this.isMobGoNative = isMobileGoNative();
    if (this.props.transparent) {
      window.addEventListener('scroll', this.onScroll);
    }
  }

  componentWillUnmount() {
    if (this.props.transparent) {
      window.removeEventListener('scroll', this.onScroll);
    }
  }



  setTextValue(e) {
    this.setState({
      textValue: e.target.value
    })
    console.log(this.state.athlete)
  }

  setAthleteValue(value){
    this.setState({
      athlete: value
    })
  }

  setGapYearValue(value) {
    this.setState({
      gapYear: value
    })
  }

  setGreekLifeValue(value) {
    this.setState({
      greekLife: value
    })
  }

  setSchoolValue(value) {
    this.setState({
      school: value
    })
  }

  setServiceValue(value){
    this.setState({
      service: value
    })
  }

  setTrackValue(value){
    this.setState({
      track: value
    })
  }


  mobileSearchFunction(event, values){
    const schoolsArray = values;
    let schoolSearchString ="";
    schoolsArray.forEach(school => {

      if(schoolsArray.indexOf(school) === schoolsArray.length - 1){
        schoolSearchString=`${schoolSearchString}${school.School}`
      } else {
        schoolSearchString=`${schoolSearchString}${school.School},`
      }
    })
    this.setSchoolValue(`&pub_combinedSchoolSearch=has_any:${schoolSearchString}`)
    if(schoolSearchString === ""){
      this.setSchoolValue("")
    }
  }


//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
  handleMobileMenuOpen() {
    redirectToURLWithModalState(this.props, 'mobilemenu');
  }

  handleMobileMenuClose() {
    redirectToURLWithoutModalState(this.props, 'mobilemenu');
  }

  handleMobileSearchOpen() {
    redirectToURLWithModalState(this.props, 'mobilesearch');
  }

  handleMobileSearchClose() {
    redirectToURLWithoutModalState(this.props, 'mobilesearch');
  }

  handleSubmit(values) {

    
  //   const unitedStatesObj = {
  //     "search": "United States",
  //     "predictions": [],
  //     "selectedPlace": {
  //         "address": "United States",
  //         "origin": {
  //             "_sdkType": "LatLng",
  //             "lat": 39.3812661305678,
  //             "lng": -97.9222112121185
  //         },
  //         "bounds": {
  //             "_sdkType": "LatLngBounds",
  //             "ne": {
  //                 "_sdkType": "LatLng",
  //                 "lat": 71.4202919997506,
  //                 "lng": -66.8847646185949
  //             },
  //             "sw": {
  //                 "_sdkType": "LatLng",
  //                 "lat": 18.8163608007951,
  //                 "lng": -179.9
  //             }
  //         }
  //     }
  // }

  //   const { currentSearchParams } = this.props;
  //   const { search, selectedPlace } = unitedStatesObj;
     const { history } = this.props;
  //   const { origin, bounds } = unitedStatesObj;
  //   const originMaybe = config.sortSearchByDistance ? { origin } : {};
  //   const searchParams = {
  //     ...currentSearchParams,
  //     ...originMaybe,
  //     address: search,
  //     bounds,
  //   };
  //   console.log("^&^&^&^&^&^&^&^&^&^&^&^&^&^&^&^&")
  //   console.log(searchParams)

  //   let searchRoute = createResourceLocatorString(
  //     'SearchPage',
  //     routeConfiguration(),
  //     {},
  //     searchParams
  //   );
    // searchRoute = `${searchRoute}&keywords=${this.state.textValue}`;
  
    let searchRoute = `/s?`;

    if ( this.state.textValue !== "") {
      searchRoute = `${searchRoute}${this.state.textValue}`;
    }

    if(this.state.athlete !== ""){
      searchRoute = `${searchRoute}${this.state.athlete}`;
    }

    if(this.state.gapYear !== ""){
      searchRoute = `${searchRoute}${this.state.gapYear}`;
    }


    if(this.state.greekLife !== ""){
      searchRoute = `${searchRoute}${this.state.greekLife}`;
    }


    if(this.state.school !== ""){
      searchRoute = `${searchRoute}${this.state.school}`;
    }

    if(this.state.service !== ""){
      searchRoute= `${searchRoute}${this.state.service}`
    }

    if(this.state.track !== ""){
      searchRoute = `${searchRoute}${this.state.track}`
    }

    if(this.state.textValue !== ""){
      searchRoute = `${searchRoute}&keywords=${this.state.textValue}`
    }

    history.push(searchRoute);

  }

  handleSubmitMobile() {
    const { history } = this.props;
    history.push(`/s?keywords=${this.state.textValue}`);

  }



  handleLogout() {
    const { onLogout, history } = this.props;
    onLogout().then(() => {
      const path = pathByRouteName('LandingPage', routeConfiguration());

      // In production we ensure that data is really lost,
      // but in development mode we use stored values for debugging
      if (config.dev) {
        history.push(path);
      } else if (typeof window !== 'undefined') {
        window.location = path;
      }

      console.log('logged out'); // eslint-disable-line
    });
  }

  onScroll() {
    if (window.scrollY > 50 && this.state.showTransparent) {
      console.log("NOT TRANSPARENT !!!!!")
      this.setState({ showTransparent: false });
      console.log(this.state.showTransparent)
    } else if (window.scrollY <= 50 && !this.state.showTransparent) {
      console.log("TRANSPARENT !!!!!")
      this.setState({ showTransparent: true });
      console.log(this.state.showTransparent)
    }
  }

  render() {
    const {
      className,
      rootClassName,
      desktopClassName,
      mobileRootClassName,
      mobileClassName,
      isAuthenticated,
      authScopes,
      authInProgress,
      currentUser,
      currentUserHasListings,
      currentUserListingFetched,
      currentUserHasOrders,
      currentUserListing,
      currentPage,
      notificationCount,
      viewport,
      intl,
      location,
      onManageDisableScrolling,
      onResendVerificationEmail,
      sendVerificationEmailInProgress,
      sendVerificationEmailError,
      showGenericError,
      hideTopbarInput,
    } = this.props;

    if (typeof document !== 'undefined') {
   if(document.getElementById("keywordId")){
    document.getElementById("keywordId").addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        this.handleSubmit(e)
      }
  });}
}

    const { mobilemenu, mobilesearch, address, origin, bounds } = parse(location.search, {
      latlng: ['origin'],
      latlngBounds: ['bounds'],
    });

    const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;

    const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
    const isMobileMenuOpen = isMobileLayout && mobilemenu === 'open';
    const isMobileSearchOpen = isMobileLayout && mobilesearch === 'open';

    const mobileMenu = (
      <TopbarMobileMenu
        isAuthenticated={isAuthenticated}
        currentUserHasListings={currentUserHasListings}
        currentUserListing={currentUserListing}
        currentUserListingFetched={currentUserListingFetched}
        currentUser={currentUser}
        onLogout={this.handleLogout}
        notificationCount={notificationCount}
        currentPage={currentPage}
      />
    );

    // Only render current search if full place object is available in the URL params
    const locationFieldsPresent = config.sortSearchByDistance
      ? address && origin && bounds
      : address && bounds;
    const initialSearchFormValues = {
      location: locationFieldsPresent
        ? {
            search: address,
            selectedPlace: { address, origin, bounds },
          }
        : null,
    };

    const classes = classNames(rootClassName || css.root, className);

    return (
      <div className={classes}>
        <LimitedAccessBanner
          isAuthenticated={isAuthenticated}
          authScopes={authScopes}
          currentUser={currentUser}
          onLogout={this.handleLogout}
          currentPage={currentPage}
        />
        <div className={classNames(mobileRootClassName || css.container, mobileClassName)}>
        <NamedLink
            className={css.home}
            name="LandingPage"
            title={intl.formatMessage({ id: 'Topbar.logoIcon' })}
          >
            <Logo format="mobile" />
          </NamedLink>
          <Button
            rootClassName={css.menu}
            onClick={this.handleMobileMenuOpen}
            title={intl.formatMessage({ id: 'Topbar.menuIcon' })}
          >
            <MenuIcon className={css.menuIcon} />
            {notificationDot}
          </Button>
          
          <Button
            rootClassName={css.searchMenu}
            onClick={this.handleMobileSearchOpen}
            title={intl.formatMessage({ id: 'Topbar.searchIcon' })}
          >
            <SearchIcon className={css.searchMenuIcon} />
          </Button>
        </div>
        <div className={css.desktop}>
          <TopbarDesktop
            className={desktopClassName}
            currentUserHasListings={currentUserHasListings}
            currentUserListingFetched={currentUserListingFetched}
            currentUserListing={currentUserListing}
            currentUser={currentUser}
            currentPage={currentPage}
            initialSearchFormValues={initialSearchFormValues}
            intl={intl}
            isAuthenticated={isAuthenticated}
            notificationCount={notificationCount}
            onLogout={this.handleLogout}
            onSearchSubmit={this.handleSubmit}
            setTextValue={this.setTextValue}
            setAthleteValue={this.setAthleteValue}
            setGapYearValue={this.setGapYearValue}
            setGreekLifeValue={this.setGreekLifeValue}
            setSchoolValue={this.setSchoolValue}
            setServiceValue={this.setServiceValue}
            setTrackValue={this.setTrackValue}
            textValue={this.textValue}
            handleSubmitSearch={this.handleSubmit}
            showTransparent={this.state.showTransparent}
            hideTopbarInput={hideTopbarInput}
            history={this.props.history}
          />
        </div>
        <Modal
          id="TopbarMobileMenu"
          isOpen={isMobileMenuOpen}
          onClose={this.handleMobileMenuClose}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
        >
          {authInProgress ? null : mobileMenu}
        </Modal>
        <Modal
          id="TopbarMobileSearch"
          containerClassName={css.modalContainer}
          isOpen={isMobileSearchOpen}
          onClose={this.handleMobileSearchClose}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <div className={css.searchContainer}>
          {/* <input
          id="keywordId"
          className={css.mobileInputClass}
          onChange={this.setTextValue}
          value={this.state.textValue}
          placeholder="Search helpers..."
        /> */}

         <UniversitySearch
           id="school"
           name="school"
           className={css.univSearch}
           searchBarFunction={this.mobileSearchFunction}
           searchBar={true}
           mobile={true}
          />  




        <Button className={css.searchButtonMobile} onClick={this.handleSubmit}>Search</Button>

          </div>
        </Modal>
        <ModalMissingInformation
          id="MissingInformationReminder"
          containerClassName={css.missingInformationModal}
          currentUser={currentUser}
          currentUserHasListings={currentUserHasListings}
          currentUserHasOrders={currentUserHasOrders}
          location={location}
          onManageDisableScrolling={onManageDisableScrolling}
          onResendVerificationEmail={onResendVerificationEmail}
          sendVerificationEmailInProgress={sendVerificationEmailInProgress}
          sendVerificationEmailError={sendVerificationEmailError}
        />

        <GenericError show={showGenericError} />
      </div>
    );
  }
}

TopbarComponent.defaultProps = {
  className: null,
  rootClassName: null,
  desktopClassName: null,
  mobileRootClassName: null,
  mobileClassName: null,
  notificationCount: 0,
  currentUser: null,
  currentUserHasOrders: null,
  currentPage: null,
  sendVerificationEmailError: null,
  authScopes: [],
};

TopbarComponent.propTypes = {
  className: string,
  rootClassName: string,
  desktopClassName: string,
  mobileRootClassName: string,
  mobileClassName: string,
  isAuthenticated: bool.isRequired,
  authScopes: array,
  authInProgress: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentUserHasListings: bool.isRequired,
  currentUserHasOrders: bool,
  currentPage: string,
  notificationCount: number,
  onLogout: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onResendVerificationEmail: func.isRequired,
  sendVerificationEmailInProgress: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  showGenericError: bool.isRequired,

  // These are passed from Page to keep Topbar rendering aware of location changes
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string.isRequired,
  }).isRequired,

  // from withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const Topbar = compose(
  withViewport,
  injectIntl
)(TopbarComponent);

Topbar.displayName = 'Topbar';

export default Topbar;
